/**
 * Typography variant constants
 * Single source of truth for all typography variants from citydrinks.css
 * VARIANT is auto-generated from VARIANT_CLASSES keys for autocomplete
 */

export const TAG = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  p: 'p',
  span: 'span',
  div: 'div',
  label: 'label',
  legend: 'legend',
} as const;

export const VARIANT_CLASSES = {
  // Header variants
  'Header 500/Regular': 'variantHeader500Regular',
  'Header 400/Medium': 'variantHeader400Medium',
  'Header 400/Light': 'variantHeader400Light',
  'Header 300/Medium': 'variantHeader300Medium',
  'Header 300/Light': 'variantHeader300Light',
  'Header 200/Light': 'variantHeader200Light',
  'Header 200/Semibold': 'variantHeader200Semibold',
  'Header 150/Medium': 'variantHeader150Medium',
  'Header 150/Light': 'variantHeader150Light',
  'Header 100/Semibold': 'variantHeader100Semibold',
  'Header 100/Medium': 'variantHeader100Medium',
  'Header 50/Medium': 'variantHeader50Medium',
  // Alt header variants
  'Alt Header 100/Semibold': 'variantAltHeader100Semibold',
  // Text variants
  'Text 600/Regular': 'variantText600Regular',
  'Text 600/Semibold': 'variantText600Semibold',
  'Text 600/Semibold Hight': 'variantText600SemiboldHight',
  'Text 500/Regular': 'variantText500Regular',
  'Text 500/Semibold': 'variantText500Semibold',
  'Text 400/Regular': 'variantText400Regular',
  'Text 400/Medium': 'variantText400Medium',
  'Text 400/Semibold': 'variantText400Semibold',
  'Text 400/Semibold High': 'variantText400SemiboldHigh',
  'Text 300/Medium': 'variantText300Medium',
  'Text 300/Medium High': 'variantText300MediumHigh',
  'Text 300/Regular': 'variantText300Regular',
  'Text 300/Regular High': 'variantText300RegularHigh',
  'Text 300/Semibold': 'variantText300Semibold',
  'Text 200/Regular': 'variantText200Regular',
  'Text 200/Regular High': 'variantText200RegularHigh',
  'Text 200/Medium': 'variantText200Medium',
  'Text 200/Medium High': 'variantText200MediumHigh',
  'Text 200/Semibold': 'variantText200Semibold',
  'Text 200/Semibold High': 'variantText200SemiboldHigh',
  'Text 100/Regular': 'variantText100Regular',
  'Text 100/Regular High': 'variantText100RegularHigh',
  'Text 100/Medium': 'variantText100Medium',
  'Text 100/Medium High': 'variantText100MediumHigh',
  'Text 100/Semibold': 'variantText100Semibold',
  'Text 50/Regular': 'variantText50Regular',
  'Text 50/Medium': 'variantText50Medium',
  'Text 50/Semibold': 'variantText50Semibold',
  'Text Body 15M': 'variantTextBody15m',
} as const;

// Auto-generated VARIANT object for autocomplete (keys map to themselves)
// This provides: VARIANT['Text 200/Medium'] === 'Text 200/Medium'
type VariantKey = keyof typeof VARIANT_CLASSES;

export const VARIANT = Object.keys(VARIANT_CLASSES).reduce(
  (acc, key) => {
    acc[key as VariantKey] = key as VariantKey;
    return acc;
  },
  {} as Record<VariantKey, VariantKey>,
) as { [K in VariantKey]: K };
